export default {
    toStamp (str) {
        return new Date(str).getTime();
    },
    toFullDate (str, format) {
        let fmt = new Date(str);
        let MM = fmt.getMonth()+1;
        let DD = fmt.getDate();
        let hh = fmt.getHours();
        let mm = fmt.getMinutes();
        let ss = fmt.getSeconds();
        return format.replace(/YY/gi, fmt.getFullYear())
        .replace(/MM/gi, MM < 10 ? `0${MM}` : MM)
        .replace(/DD/gi, DD < 10 ? `0${DD}` : DD)
        .replace(/hh/gi, hh < 10 ? `0${hh}` : hh)
        .replace(/mm/gi, mm < 10 ? `0${mm}` : mm)
        .replace(/ss/gi, ss < 10 ? `0${ss}` : ss);
    }
}